<script>
export default {
    name: 'RegisterStepper',
    props: {
        activeStep: {
            type: Number,
            default: 1,
        },
    },
    methods: {
        setStep(step) {
            this.$emit('setStep', step);
        },
    },
};
</script>

<template>
    <div>
        <a
            v-if="activeStep > 1"
            @click="setStep(activeStep - 1)"
            href="javascript:;"
            class="back-btn text-secondary"
        >
            <i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>
            Back
        </a>
        <div class="register-stepper-wrap">
            <div
                v-for="step in [1, 2, 3]"
                v-bind:key="step"
                class="step"
                :class="{ active: activeStep === step }"
                v-text="step"
            ></div>
        </div>
        <a
            v-if="activeStep > 1"
            @click="setStep(activeStep - 1)"
            href="javascript:;"
            class="back-btn bottom text-secondary"
        >
            <i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>
            Back
        </a>
    </div>
</template>

<style scoped lang="scss">
.back-btn {
    position: absolute;
    left: 1px;
    top: -30px;

    &.bottom {
        top: auto;
        bottom: -40px;
    }
}
.register-stepper-wrap {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -20px;
    display: flex;
    justify-content: space-between;

    .step {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #ffffff;
        color: #1b659e;
        display: flex;
        border: 1px solid #1b659e;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        margin-left: 10px;

        &.active {
            background: #1b659e;
            color: #ffffff;
        }
    }
}
</style>
